import { BaseClient } from '../client';
import { veiculosModelos } from '../offer/offer.mocks';
import { TVeiculoModelo } from '../offer/offer.types';

export const getVehicleModels = async (idVehicleBrand: number | string) => {
	if (process.env.NODE_ENV === 'development') {
		const response: TVeiculoModelo[] = [];

		veiculosModelos.forEach((modelo) => {
			if (modelo.veiculoMarca.id === idVehicleBrand) response.push(modelo);
		});

		return response;
	}
	try {
		const response = await BaseClient.get<TVeiculoModelo[]>(`/VeiculoModelos/GetVeiculoModelosPorIdMarca/${idVehicleBrand}`).then((response) => response.data);

		return response;
	} catch (error) {
		throw error;
	}
};
